// components/PatientDischargeAndSaveStatus.tsx
import DischargePatientModal from '@/pages/DischargePatientModal';
import { Box, Chip, Link } from '@mui/material';
import React from 'react';
import type { PatientDetailsDataState } from '../hooks/usePatientDetailsData';

interface PatientDischargeAndSaveStatusProps {
  data: PatientDetailsDataState;
  patientId: number;
  user: any;
  isNurse: boolean;
  isSuperAdmin?: boolean;
  isManager?: boolean;
  isAdminOnly?: boolean;
  dischargeModalOpen: boolean;
  setDischargeModal: (open: boolean) => void;
  handleDischargeModalClose: (status: boolean) => void;
  isSaving: boolean;
  isLoading: boolean;
}

const PatientDischargeAndSaveStatus: React.FC<PatientDischargeAndSaveStatusProps> = ({
  data,
  patientId,
  user,
  isNurse,
  isSuperAdmin,
  isManager,
  isAdminOnly,
  dischargeModalOpen,
  setDischargeModal,
  handleDischargeModalClose,
}) => {
  const canDischarge =
    data.isActive && (isNurse || isSuperAdmin || isManager) && !isAdminOnly && data?.discharge_status !== 'Active';

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column-reverse', sm: 'column-reverse', md: 'row', lg: 'row' }}
      justifyContent="space-between"
      alignItems="center"
      py={2}
      gap={1}
    >
      {canDischarge && (
        <>
          <Link
            onClick={() => setDischargeModal(true)}
            sx={{
              color: 'warning',
              textDecoration: 'underline !important',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: 16,
            }}
          >
            Discharge Patient
          </Link>
          <DischargePatientModal
            open={dischargeModalOpen}
            setOpen={handleDischargeModalClose}
            data={data}
            patient_id={patientId}
            userId={user?.id}
          />
        </>
      )}
      {!data.isActive &&
        (data.discharge_status ? (
          <Chip color="error" label={data.discharge_status} />
        ) : (
          <Chip color="warning" label="Inactive" />
        ))}
    </Box>
  );
};

export default PatientDischargeAndSaveStatus;
